const Country = {
  CA: 'CA',
  US: 'US',
  AU: 'AU'
};

export const CountryOrder = [Country.CA, Country.US, Country.AU];

export default Country;
